<div class="wrapper">
  <mat-form-field [appearance]="'outline'" class="phone-number" *ngIf="ngControl.control as control">
    <mat-label *ngIf="label"> {{ label }}{{ isFieldRequired(control) }} </mat-label>
    <input
      [(ngModel)]="timeValue"
      matInput
      [owlDateTime]="timePicker"
      [owlDateTimeTrigger]="timePicker"
      [min]="minTime"
      [max]="maxTime"
      [readonly]="true"
      placeholder="00:00"
      type="text"
      (dateTimeChange)="onTimeValueChanged($event)"
    />
    <owl-date-time #timePicker [pickerType]="'timer'"></owl-date-time>
  </mat-form-field>
</div>
